import jsonp from 'jsonp';
  import parser from 'ua-parser-js';
  import * as _ from 'lodash-es';
  import Fingerprint2 from 'fingerprintjs2';
  import excmd5 from "md5";
  import * as request from "@/api/request";

  export const md5 = excmd5;

  export const getUrlParams = (name) => {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return '';
  };
  
  export const getMainHost = () => {
    if (window.location.hostname == 'localhost') {
      return '37games.com';
    }
    let hostArr = window.location.hostname.split('.');
    let mainArr = hostArr.slice(-2);
    return mainArr.join('.');
  };
  
  export const getCurYear = () => {
    return `${new Date().getFullYear()}`;
  };
  
  export const sdk = (action, params) => {
    if (!action) return;
    try {
      if (params !== void 0) {
        window.sdkCtrl[action](params);
      } else {
        window.sdkCtrl[action]();
      }
    } catch (error) {
      try {
        window.webkit.messageHandlers.callSDKMethodWithParameters.postMessage({
          method: action,
          params,
        });
      } catch (error) {}
    }
  };
  
  export const sleep = async (second) => {
    return new Promise((resolve) => {
      setTimeout(resolve, second * 1000);
    });
  };
  
  // 这个库一共可以识别console, mobile, tablet, smarttv, wearable, embedded，其中桌面是undefined。
  export const isMobileType = () => {
    let info = parser();
    if (info) {
      if (info.device.type == undefined) return false;
      if (info.device.type == 'tablet' || info.device.type == 'smarttv') {
        return window.innerHeight > window.innerWidth;
      }
    }
    return true;
  };
  
  export const getDeviceInfo = () => {
    return parser();
  };
  
  export const getUrlParamObj = (ignoreKeyArr) => {
    let search = window.location.search.substr(1);
    let res = {};
    let keyArr = search.split('&');
    for (let i in keyArr) {
      let arr = keyArr[i].split('=');
      if (ignoreKeyArr?.length && _.isArray(ignoreKeyArr)) {
        let _i = ignoreKeyArr.findIndex((item) => item == arr[0]);
        if (~_i) continue;
      }
      res[arr[0]] = arr[1];
    }
  
    return res;
  };
  
  export const getSystemLanguage = function () {
    let res =
      navigator.language ||
      navigator.userLanguage ||
      navigator.browerLanguage ||
      navigator.systemLanguage;
    if (res.indexOf('-') > -1) {
      const langArr = res.split('-');
      res = langArr[0] === 'zh' ? langArr[1] : langArr[0];
    }
    return res.toLowerCase();
  };
  
  const createFingerPrint = async (data = {}) => {
    return new Promise((resolve) => {
      Fingerprint2.get((components) => {
        // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
        let values = components.map((component) => component.value) // 配置的值的数组
        for (let i in data) {
          values.push(data[i])
        }
        const murmur = Fingerprint2.x64hash128(values.join(''), 31) // 生成浏览器指纹
        resolve(murmur)
      })
    })
  }
  
  export const getFingerPrint = async (data = {}) => {
    let local = ''
    try {
      local = window.localStorage.getItem('finger_id_2')
    } catch (error) {}
    if (!local) {
      if (!Object.keys(data).length) {
        let res = await request.getJSON('//gstore.endomainname.com/test_ip')
        if (res.result == 1) {
          data = res.data
        }
      }
      local = await createFingerPrint(data)
      try {
        window.localStorage.setItem('finger_id_2', local)
      } catch (error) {}
    }
    return local
  }
  
  // 旧版通用的判断设备逻辑
  export const getDeviceOld = () => {
    var userAgent = window.navigator.userAgent;
    var ua = userAgent.toLowerCase();
    var platform = {
      isAndroid: function () {
        return ua.indexOf('android') > -1;
      },
      isIOS: function () {
        var NPlatform = navigator.platform;
        return (
          ua.indexOf('iphone') > -1 ||
          /iPad|iPhone|iPod/gi.test(NPlatform) ||
          (NPlatform === 'MacIntel' &&
            navigator.maxTouchPoints > 1 &&
            !window.MSStream)
        );
      },
      isWinPhone: function () {
        return !!navigator.userAgent.match(/Windows Phone/i);
      },
      isIpad: function () {
        return ua.indexOf('ipad') > -1;
      },
      isPhone: function () {
        return (
          this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
        );
      },
    };
    return platform;
  };

  export const systemType = ()=>{
    let _p = getDeviceOld();
    return _p.isIOS()|| _p.isIpad() ?"ios":_p.isAndroid()||_p.isWinPhone()?"android":"pc";
  }

  export const getGapi = (shost) => {
    return `${getMainHost() == 'gm99.com' ? '' : 'g'}${shost}.${getMainHost()}`;
  };

  export const setCookie = (name, value, days, safe) => {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + date.toGMTString();
    let safeTxt = "Secure; SameSite=None;";
    if(safe){
      safeTxt = "";
    }
    document.cookie = `${name}=${value};${expires};path=/;${safeTxt}domain=.${getMainHost()}`;
  };

  export const getCookie = (name) => {
    let arr;
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) return arr[2];
    return '';
  };

  export const randomNumber = (min, max) => {
    const randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    const number = randomBuffer[0] / (0xffffffff + 1);
    return Math.floor(number * (max - min) + min);
  };

  export const updateLinkParams = (link, obj) => {
    try {
      let url = new URL(link);
      for (let k in obj) {
        url.searchParams.set(k, String(obj[k]));
      }
      return url.href;
    } catch (error) {
      return String(link);
    }
  };
  // 获取带有cid、scid的储值链接
  export const getStoreLinkWithCidScid = ({ link, paramsObj, pageId }) => {
    if (!link) return "";
    let res = updateLinkParams(link);
    const cid = getUrlParams("cid");
    const scid = getUrlParams("scid");
    let storeLinkCid = "web";
    let storeLinkScid = `activity_${pageId}`;
    if (cid) {
      storeLinkCid = cid;
    }
    if (scid) {
      storeLinkScid = `${scid}_activity_${pageId}`;
    } 
    res = updateLinkParams(res, {
      cid: storeLinkCid,
      scid: storeLinkScid,
      ...paramsObj,
    });
    return res;
  };
  // 活动及储值页的常用域名，用于替换链接中的域名
  export const mainLinkArr = [
    "pay",
    "gabres",
    "gevents",
    "auto-page",
    "auto-page-preview",
  ];
  // 二级域名包含活动及储值页的常用域名时标记为需要替换域名的链接
  export const checkMainLink = (link) => {
    let hostArr = link.split(".");
    if (hostArr.length < 2) return false;
    let linkHost = hostArr[0];
    if (linkHost.indexOf("//") > -1) {
      linkHost = linkHost.split("//")[1];
    }
    return mainLinkArr.includes(linkHost);
  };
  // 获取最终跳转的链接
  export const getTargetLink = (link) => {
    if (checkMainLink(link)) {
      // 替换link中的mainHost为当前域名中的mainHost
      let hostArr = link.split(".");
      hostArr[1] = window.location.hostname.split(".")[1];
      return hostArr.join(".");
    }
    return link;
  };

  // 这些都是新旧版本的兼容代码
export const getUrlParms = getUrlParams;
export const getJSON = request.getJSON;

 
  
  